import axiosHandler from "../../Intersepter/axiosInstance";

export const getUserDetail = async (id) => {
    try {
        const response = await axiosHandler.get(`/user/detail/${id}`);
        return response;
    } catch (error) {
        console.error("Error fetching user details:", error);
        throw error;
    }
};